import api from './api';

const TeamService = {
  createTeam: (data) => api.post('/teams', data),
  getMyTeam: () => api.get('/teams/me'),
  getInvites: () => api.get('/teams/invites'),
  inviteMember: (teamId, data) => api.post(`/teams/${teamId}/invite`, data),
  respondToInvite: (teamId, data) => api.post(`/teams/${teamId}/respond`, data),
  removeMember: (teamId, memberId) => api.delete(`/teams/${teamId}/members/${memberId}`),
};

export default TeamService;
